/* eslint-disable */
import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

// Import CKEditor here (both required).
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

/*import url and gateway methods */
import { getData, postData, putData, uploadMultipleFile } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { downloadFileHandler } from "helper/FileDownload/DownloadFile";

const CreatePostModal = ({
  editedForumId,
  eventId,
  setEditedForumId,
  setIsEdit,
}) => {
  /*---- CKEditor classic editor configuration start ----- */
  const editorConfig = {
    toolbar: ["bold", "italic", "link", "bulletedList", "numberedList"],
    ckfinder: {
      // Upload the images to the server using the CKFinder QuickUpload command.
      //   uploadUrl: url.URL_TEXT_EDITOR_IMAGE_UPLOAD_2,
    },
    placeholder: "Type details here...",
  };
  /*---- CKEditor classic editor configuration end ----- */

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const token = localStorage.getItem("token");

  const [title, settitle] = useState("");
  const [description, setdescription] = useState("");

  const [isPosting, setisPosting] = useState(false);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadedFileIds, setUploadedFileIds] = useState([]);

  //function for file upload
  const uploadHandler = async (e) => {
    try {
      setIsUploading(true);
      let requestUrl =
        url.API_BASE_URL + url.API_MULTIPLE_FILE_UPLOAD + `?token=${token}`;

      const response = await uploadMultipleFile(requestUrl, e.target.files);

      console.log(
        `response in file upload mail template------>`,
        response.data
      );

      if (response.status) {
        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/

        setIsUploading(false);

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data.map(({ _id, ...other }) => ({ _id }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedFileIds.length == 0) {
          setUploadedFileIds(fileIds);
        } else {
          let fileArr = uploadedFileIds.concat(fileIds);
          setUploadedFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
        resetFile();
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for delete file from upload stack
  const closeFileHandler = (index) => {
    const closedFile = [...uploadedFiles];
    const removedFileId = [...uploadedFileIds];

    closedFile.splice(index, 1);
    removedFileId.splice(index, 1);

    setUploadedFiles(closedFile);
    setUploadedFileIds(removedFileId);

    resetFile();
  };

  // function for clear file value
  const resetFile = () => {
    const file = document.getElementById("uploadFile");
    if (file) {
      file.value = null;
    } else {
      return;
    }
  };

  //get details
  const getPostDetails = async () => {
    setisPosting(true);
    try {
      let requestURL =
        url.API_BASE_URL + url.API_GUEST_FORUM_DETAILS + `/${editedForumId}`;

      const response = await getData(requestURL);

      setisPosting(false);

      console.log(response);

      if (response.status) {
        settitle(response.data.title);
        setdescription(response.data.description);

        /*----- assign uploaded files with path for display start ------*/
        const uploadedFileValues = response.data?.uploads.map(
          ({ name, path, _id, ...other }) => ({
            name,
            path: url.SERVER_URL + path,
            _id,
          })
        );

        //check old file exist or not if exist then new file will concat with old file
        if (uploadedFiles.length == 0) {
          setUploadedFiles(uploadedFileValues);
        } else {
          let fileArr = uploadedFiles.concat(uploadedFileValues);
          setUploadedFiles(fileArr);
        }
        /*----- assign uploaded files with path for display end ------*/

        /*----- assign uploaded file ids start ------*/
        const fileIds = response.data?.uploads?.map(({ _id, ...other }) => ({
          _id,
        }));

        //check old file ids are exist or not.If exist then new id will concat with old id
        if (uploadedFileIds.length == 0) {
          setUploadedFileIds(fileIds);
        } else {
          let fileArr = uploadedFileIds.concat(fileIds);
          setUploadedFileIds(fileArr);
        }
        /*----- assign uploaded file ids end ------*/
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //save post
  const savePostHandler = async () => {
    try {
      let forumData = {
        title,
        description,
        uploads: uploadedFileIds,
        isprivate: false,
        eventid: eventId,
      };

      let requestURL = url.API_BASE_URL;

      let response = null;

      if (editedForumId) {
        requestURL =
          requestURL +
          url.API_UPDATE_FORUM +
          `/${editedForumId}` +
          `?token=${token}`;

        response = await putData(requestURL, forumData);
        setIsEdit(true);
      } else {
        requestURL = requestURL + url.API_CREATE_FORUM + `?token=${token}`;
        response = await postData(requestURL, forumData);
        setIsEdit(false);
      }

      resetHandler();

      console.log(response);

      if (response.status) {
        //hide login modal
        let postModal = document.querySelector("#question_modal");
        let modal = bootstrap.Modal.getInstance(postModal);
        modal.hide();

        //show otpconfirm modal
        let myModal = new bootstrap.Modal(
          document.getElementById("success_mdl")
        );
        myModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //reset
  const resetHandler = () => {
    settitle("");
    setdescription("");
    setUploadedFileIds([]);
    setUploadedFiles([]);
    setEditedForumId(null);
  };

  useEffect(() => {
    if (editedForumId) {
      getPostDetails();
    }
  }, [editedForumId]);

  return (
    <div className=" invite_modal common_modal">
      <div
        className="modal fade"
        id="question_modal"
        data-bs-backdrop="static"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0 px-5">
              <div className="modal_hdng">
                <h3 className="text-primary text-uppercase fs-lg">
                  POst Details
                </h3>
              </div>
              <button
                type="button"
                className="close d-flex align-items-center justify-content-center rounded-circle"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetHandler}
              >
                <i className="material-icons-outlined">close</i>
              </button>
            </div>
            <div className="modal-body p-5">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="invite_area">
                  <div className="invite_item mb-4">
                    <div className="input_fill jobinput_fill">
                      <label className="text-black fw-medium">
                        Post Your Reply
                      </label>
                      <input
                        type="text"
                        className="form-control bg-white"
                        placeholder="Be specific and imagine you're asking a question to another person"
                        value={title}
                        onChange={(e) => settitle(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="invite_item mb-4">
                    <div className="input_fill description_fill">
                      <label className="text-black fw-medium">Details</label>
                      <div className="editor_pnl">
                        <CKEditor
                          className="form-control bg-white p-3"
                          editor={ClassicEditor}
                          config={editorConfig}
                          data={description}
                          onReady={(editor) => {
                            editor.editing.view.change((writer) => {
                              writer.setStyle(
                                "height",
                                "200px",
                                editor.editing.view.document.getRoot()
                              );
                            });
                          }}
                          onChange={(event, editor) => {
                            let editorContent = editor.getData();
                            setdescription(editorContent);
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* file upload */}
                  <div className="invite_item mb-4">
                    <div className="input_fill jobinput_fill">
                      <label className="text-black fw-medium">Media</label>
                      <div className="media_outer d-flex align-items-center gap-3">
                        <div className="media_item d-flex align-items-center justify-content-center p-3">
                          <div className="media_upload_bx text-center">
                            <input
                              type="file"
                              className="file_btn"
                              id="uploadFile"
                              onChange={uploadHandler}
                              multiple
                            />
                            <span className="d-block material-icons-outlined mb-2">
                              file_upload
                            </span>
                            <h5 className="text-primary fw-semibold fs-sm mb-2">
                              Upload Image
                            </h5>
                            <h5 className="text-primary fw-semibold fs-sm">
                              1024x640
                            </h5>
                          </div>
                        </div>

                        {/* uploaded file preview */}
                        {uploadedFiles.length > 0
                          ? uploadedFiles.map((file, index) => {
                              return (
                                <div className="media_item" key={index}>
                                  <div className="upload_img position-relative h-100">
                                    <img src={file.path} alt="" />
                                    <div className="caption_upload d-flex align-items-center gap-2">
                                      <Link
                                        to="#"
                                        className="d-inline-block"
                                        onClick={() =>
                                          downloadFileHandler(file)
                                        }
                                      >
                                        <span className="material-icons-outlined fs-lg text-white">
                                          download
                                        </span>
                                      </Link>
                                      <Link
                                        to="#"
                                        className="d-inline-block"
                                        onClick={() => closeFileHandler(index)}
                                      >
                                        <span className="material-icons-outlined fs-lg text-white">
                                          delete
                                        </span>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  </div>

                  <div className="invite_item">
                    <div className="revw_submit d-flex gap-2 align-items-center">
                      <button
                        className="btn primary-btn"
                        onClick={savePostHandler}
                        disabled={isPosting ? true : false}
                        style={{
                          cursor: isPosting ? "not-allowed" : "pointer",
                        }}
                      >
                        Submit your question
                        {isPosting && (
                          <div
                            className="mx-2 spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        )}
                      </button>
                      <button
                        onClick={resetHandler}
                        className="btn white_btn text-black"
                        data-bs-dismiss="modal"
                        // data-bs-toggle="modal"
                        // data-bs-target="#success_mdl"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePostModal;
